module.exports = __webpack_public_path__ + "static/media/hab8-1.c267a040.jpg";